import { createI18n } from 'vue-i18n'

const messages = {
    en: {
        home: 'Home',
        all_vehicles: 'All Vehicles',
        about_us: 'About Us',
        contact_nav: 'Contact',
        sell_car: "Sell your car",
        see_all_vehicles: 'See all vehicles',
        welcome_to_bass_motors: 'WELCOME TO BASS MOTORS',
        search: 'Search',
        all_brands: 'All Brands',
        any_price: 'Any Price',
        price_under_5000: 'Under €5,000',
        price_5000_10000: '€5,000 - €10,000',
        price_10000_20000: '€10,000 - €20,000',
        price_20000_50000: '€20,000 - €50,000',
        price_50000_100000: '€50,000 - €100,000',
        price_over_100000: 'Over €100,000',
        any_fuel_type: 'Any Fuel Type',
        fuel_types: {
            gasoline: 'Gasoline',
            diesel: 'Diesel',
            electric: 'Electric',
            hybrid: 'Hybrid',
            'electric/gasoline': 'Electric/Gasoline',
            'electric/diesel': 'Electric/Diesel'
        },
        latest_cars: 'Latest Cars',
        customer_reviews: 'Customer Reviews',
        quick_links: 'Quick Links',
        contact_info: 'Contact Info',
        opening_hours: 'Opening Hours',
        follow_us: 'Follow Us',
        copyright: '© {year} Bass Motors. All Rights Reserved.',
        monday_friday: 'Lundi - Vendredi: 10h00 - 18h00',
        saturday: 'Samedi: 10h30 - 18h00',
        sunday: 'Sunday: Closed',
        by_appointment_only: 'BY APPOINTMENT ONLY',
        loading_car_details: 'Loading car details...',
        back_to_listings: 'Back to Listings',
        kilometers: 'km',
        specs: {
            make: 'Make',
            model: 'Model',
            year: 'Year',
            price: 'Price',
            mileage: 'Mileage',
            fuel_type: 'Fuel Type',
            transmission: 'Transmission',
            power: 'Power',
            doors: 'Doors',
            color: 'Color'
        },
        description: 'Description',
        no_description: 'No description available.',
        interested_title: 'Interested in this car?',
        interested_text: 'Contact us for more information or to schedule a test drive.',
        contact_seller: 'Contact Seller',
        load_error: 'Failed to load car details',

        filter_options: "Filter Options",
        reset_all: "Reset All",
        available_vehicles: "Available Vehicles",
        results: "results",
        loading_vehicles: "Loading vehicles...",
        error_title: "Something went wrong",
        try_again: "Try Again",
        no_vehicles_match: "No vehicles match your criteria",
        try_adjusting_filters: "Try adjusting your filters or",
        reset_all_filters: "reset all filters",
        sort: {
            price_low_to_high: "Price: Low to High",
            price_high_to_low: "Price: High to Low",
            newest_first: "Newest First",
            lowest_mileage: "Lowest Mileage"
        },

        brand: "Brand",
        price_range: "Price Range",
        min_price: "Min €",
        max_price: "Max €",
        to: "to",
        fuel_type: "Fuel Type",

        transmissions: {
            manual: "Manual",
            automatic: "Automatic"
        },

        // about: {
        //     title: "About Our Car Marketplace",
        //     subtitle: "Your trusted partner in finding the perfect vehicle",
        //     our_story: "Our Story",
        //     story_part1: "Since 2002, Bass Motors has been committed to providing high-quality second-hand vehicles at fair prices. With over two decades of experience in the automotive industry, we’ve built a solid reputation for trust, reliability, and customer satisfaction.\n\nAt Bass Motors, our goal is simple: to help you find the right car that fits your needs and budget, without compromise. Every vehicle we sell is carefully inspected to ensure it meets our standards of quality and safety.\n\nWhether you're buying your first car or upgrading to something new, you can count on our team for honest advice, transparent service, and continued support even after the sale.\n\nYour satisfaction is our priority.\nWelcome to Bass Motors — where your journey begins.",
        //     story_part2: "We pride ourselves on our rigorous vehicle inspection process and our commitment to providing accurate, detailed information about every car in our inventory."
        // },
    
        about: {
            title: "About Us",
            subtitle: "Committed to excellence since 2002.",
            our_story: "Our Story",
            story_part1: "Since 2002, Bass Motors has been committed to providing high-quality second-hand vehicles at fair prices. With over two decades of experience in the automotive industry, we’ve built a solid reputation for trust, reliability, and customer satisfaction.",
            story_part2: "Your satisfaction is our priority. Welcome to Bass Motors — where your journey begins."
        },
        
          
        contact: {
            title: "Contact Us",
            subtitle: "Have questions? Send us a message and we'll get back to you as soon as possible.",
            success_title: "Message Sent!",
            success_message: "Thank you for contacting us. We'll get back to you soon.",
            error_title: "Error Sending Message",
            error_message: "An unexpected error occurred. Please try again later.",
            about_car: "You're contacting us about: {make} {model} ({year})"
        },
        contact_form: {
            name: "Name",
            name_placeholder: "Your name",
            email: "Email",
            email_placeholder: "your@email.com",
            phone: "Phone",
            phone_placeholder: "Your phone number",
            message: "Message",
            message_placeholder: "Your message...",
            cancel: "Cancel",
            submit: "Submit",
            regarding_car: "Regarding vehicle",
            message_about_car_placeholder: "Your message about this vehicle..."
        },

        car_power: {
            kilowatts: 'kW',
            horse_power: 'HP',
        },
        sell_car_form: {
            title: "Sell Your Car",
            subtitle: "Fill out the form below to get started.",
            error_title: "Error Sending Message",
            name: "Name",
            name_placeholder: "Enter your name",
            email: "Email",
            email_placeholder: "Enter your email",
            phone: "Phone",
            phone_placeholder: "Optional phone number",
            brand: "Car Brand",
            brand_placeholder: "Enter the car brand",
            model: "Car Model",
            model_placeholder: "Enter the car model",
            year: "Year",
            year_placeholder: "Enter the manufacturing year",
            mileage: "Mileage",
            mileage_placeholder: "Enter the mileage (km)",
            car_state_placeholder: "Select the car's condition",
            car_information: "Car Information",
            message: "Message",
            message_placeholder: "Optional additional information",
            images: "Upload Photos",
            images_hint: "You can upload multiple pictures.",
            cancel: "Cancel",
            submit: "Submit",
            car_state: "Car state",
            car_states: {
                excellent: "Excellent",
                very_good: "Very Good",
                good: "Good",
                fair: "Fair",
                needs_repair: "Needs Repair"
            },
            success_title: "Success!",
            success_message: "Your car sale form has been submitted successfully.",
            error_message: "An error occurred while submitting your car sale form. Please try again."
        },

        description_car_detail: "Our vehicles are sold with:<br><br>\
        <ul>\
          <li>12-month warranty</li>\
          <li>Pre-sale inspection</li>\
          <li>Maintenance upon delivery</li>\
          <li>Car-Pass</li>\
        </ul>\
        <br>\
        BY APPOINTMENT ONLY",

        equipment: 'Equipment',

        colors: {
            black: 'Black',
            white: 'White',
            silver: 'Silver',
            gray: 'Gray',
            red: 'Red',
            blue: 'Blue',
            green: 'Green',
            yellow: 'Yellow',
            orange: 'Orange',
            brown: 'Brown',
            beige: 'Beige',
            gold: 'Gold',
            purple: 'Purple',
            pink: 'Pink',
            grey: 'Grey',
        },

        privacy: {
            title: "Privacy Policy",
            last_updated: "Last updated: May 20, 2025",
            introduction: {
                title: "Introduction",
                content: "At BASS MOTORS, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services."
            },
            data_collection: {
                title: "Data We Collect",
                content: "We may collect personal information that you voluntarily provide to us when you:",
                items: [
                    "Register on our website",
                    "Contact us through forms or email",
                    "Express interest in our vehicles",
                    "Request information about our services",
                    "Submit a car for sale"
                ]
            },
            data_use: {
                title: "How We Use Your Data",
                content: "We use the information we collect to provide and improve our services, communicate with you, process transactions, personalize your experience, and for other legitimate business purposes."
            },
            data_sharing: {
                title: "Data Sharing",
                content: "We do not sell your personal information. We may share information with trusted third parties who assist us in operating our website and conducting our business, as long as those parties agree to keep this information confidential."
            },
            cookies: {
                title: "Cookies and Tracking Technologies",
                content: "We use cookies and similar tracking technologies to track activity on our website and hold certain information to improve your browsing experience. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent."
            },
            user_rights: {
                title: "Your Rights",
                content: "Depending on your location, you may have certain rights regarding your personal information, including:",
                rights: [
                    "The right to access your data",
                    "The right to correct inaccurate data",
                    "The right to request deletion of your data",
                    "The right to restrict processing of your data",
                    "The right to data portability",
                    "The right to withdraw consent"
                ]
            },
            security: {
                title: "Data Security",
                content: "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission or electronic storage is completely secure."
            },
            changes: {
                title: "Changes to This Policy",
                content: "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the 'last updated' date."
            },
            contact: {
                title: "Contact Us",
                content: "If you have any questions about this Privacy Policy or your personal data, please contact us through our contact page."
            }
        }
    },
    nl: {
        home: 'Home',
        all_vehicles: 'Alle voertuigen',
        about_us: 'Over ons',
        contact_nav: 'Contact',
        sell_car: "Verkoop uw wagen",
        see_all_vehicles: 'Bekijk alle voertuigen',
        welcome_to_bass_motors: 'WELKOM BIJ BASS MOTORS',
        search: 'Zoeken',
        all_brands: 'Alle merken',
        any_price: 'Elke prijs',
        price_under_5000: 'Minder dan €5.000',
        price_5000_10000: '€5.000 - €10.000',
        price_10000_20000: '€10.000 - €20.000',
        price_20000_50000: '€20.000 - €50.000',
        price_50000_100000: '€50.000 - €100.000',
        price_over_100000: 'Meer dan €100.000',
        any_fuel_type: 'Elk brandstoftype',
        fuel_types: {
            gasoline: 'Benzine',
            diesel: 'Diesel',
            electric: 'Elektrisch',
            hybrid: 'Hybride',
            'electric/gasoline': 'Elektrisch/Benzine',
            'electric/diesel': 'Elektrisch/Diesel'
        },
        latest_cars: 'Nieuwste auto\'s',
        customer_reviews: 'Klantbeoordelingen',
        quick_links: 'Snelle links',
        contact_info: 'Contactgegevens',
        opening_hours: 'Openingsuren',
        follow_us: 'Volg ons',
        copyright: '© {year} Bass Motors. Alle rechten voorbehouden.',
        monday_friday: 'Maandag - Vrijdag: 10:00 - 18:00',
        saturday: 'Zaterdag: 10:30 - 18:00',
        sunday: 'Zondag: Gesloten',
        by_appointment_only: 'ENKEL OP AFSPRAAK',
        loading_car_details: 'Auto details laden...',
        back_to_listings: 'Terug naar overzicht',
        kilometers: 'km',
        specs: {
            make: 'Merk',
            model: 'Model',
            year: 'Jaar',
            price: 'Prijs',
            mileage: 'Kilometerstand',
            fuel_type: 'Brandstoftype',
            transmission: 'Transmissie',
            power: 'Vermogen',
            doors: 'Deuren',
            color: 'Kleur'
        },
        description: 'Beschrijving',
        no_description: 'Geen beschrijving beschikbaar.',
        interested_title: 'Geïnteresseerd in deze auto?',
        interested_text: 'Neem contact met ons op voor meer informatie of om een proefrit te plannen.',
        contact_seller: 'Contacteer verkoper',
        load_error: 'Kon autogegevens niet laden',

        filter_options: "Filteropties",
        reset_all: "Alles resetten",
        available_vehicles: "Beschikbare voertuigen",
        results: "resultaten",
        loading_vehicles: "Voertuigen laden...",
        error_title: "Er is iets misgegaan",
        try_again: "Probeer opnieuw",
        no_vehicles_match: "Geen voertuigen voldoen aan uw criteria",
        try_adjusting_filters: "Probeer uw filters aan te passen of",
        reset_all_filters: "reset alle filters",
        sort: {
            price_low_to_high: "Prijs: Laag naar hoog",
            price_high_to_low: "Prijs: Hoog naar laag",
            newest_first: "Nieuwste eerst",
            lowest_mileage: "Laagste kilometerstand"
        },

        brand: "Merk",
        price_range: "Prijsbereik",
        min_price: "Min €",
        max_price: "Max €",
        to: "tot",
        fuel_type: "Brandstoftype",

        transmissions: {
            manual: "Handmatig",
            automatic: "Automatisch"
        },

        // about: {
        //     title: "Over ons wagenpark",
        //     subtitle: "Uw vertrouwde partner in het vinden van het perfecte voertuig",
        //     our_story: "Ons Verhaal",
        //     story_part1: "Sinds 2002 staat Bass Motors garant voor de verkoop van kwalitatieve tweedehandswagens aan eerlijke prijzen. Met meer dan twintig jaar ervaring in de autosector hebben we een sterke reputatie opgebouwd op vlak van betrouwbaarheid, service en klanttevredenheid.\n\nBij Bass Motors is ons doel eenvoudig: jou helpen de juiste wagen te vinden die perfect aansluit bij jouw wensen en budget. Elke wagen in ons aanbod wordt zorgvuldig gecontroleerd op kwaliteit en veiligheid.\n\nOf je nu op zoek bent naar je eerste auto of een upgrade plant, je kan rekenen op ons voor eerlijk advies, transparante service en persoonlijke opvolging.\n\nJouw tevredenheid is onze prioriteit.\nWelkom bij Bass Motors – waar jouw rit begint.",
        //     story_part2: "We zijn trots op ons grondige voertuiginspectieproces en onze inzet om nauwkeurige, gedetailleerde informatie te verstrekken over elke auto in ons aanbod."
        // },
        
        about: {
            title: "Over ons",
            subtitle: "Toegewijd aan kwaliteit sinds 2002.",
            our_story: "Ons verhaal",
            story_part1: "Sinds 2002 staat Bass Motors garant voor de verkoop van kwalitatieve tweedehandswagens aan eerlijke prijzen. Met meer dan twintig jaar ervaring in de autosector hebben we een sterke reputatie opgebouwd op vlak van betrouwbaarheid, service en klanttevredenheid.",
            story_part2: "Jouw tevredenheid is onze prioriteit. Welkom bij Bass Motors – waar jouw rit begint."
        },
        
          

        contact: {
            title: "Contacteer Ons",
            subtitle: "Heeft u vragen? Stuur ons een bericht en we nemen zo snel mogelijk contact met u op.",
            success_title: "Bericht verstuurd!",
            success_message: "Bedankt voor uw bericht. We nemen zo snel mogelijk contact met u op.",
            error_title: "Fout bij verzenden",
            error_message: "Er is een onverwachte fout opgetreden. Probeer het later nog eens.",
            about_car: "U neemt contact met ons op over: {make} {model} ({year})",
        },

        contact_form: {
            name: "Naam",
            name_placeholder: "Uw naam",
            email: "E-mail",
            email_placeholder: "uw@email.com",
            phone: "Telefoon",
            phone_placeholder: "Uw telefoonnummer",
            message: "Bericht",
            message_placeholder: "Uw bericht...",
            cancel: "Annuleren",
            submit: "Verzenden",
            regarding_car: "Betreffende voertuig",
            message_about_car_placeholder: "Uw bericht over dit voertuig...",
        },

        car_power: {
            kilowatts: 'kW',
            horse_power: 'PK',
        },
        sell_car_form: {
            title: "Verkoop uw wagen",
            subtitle: "Vul het onderstaande formulier in om te beginnen.",
            error_title: "Fout bij het verzenden van het bericht",
            name: "Naam",
            name_placeholder: "Voer uw naam in",
            email: "E-mail",
            email_placeholder: "Voer uw e-mail in",
            phone: "Telefoon",
            phone_placeholder: "Optioneel telefoonnummer",
            brand: "Automerk",
            brand_placeholder: "Voer het automerk in",
            model: "Automodel",
            model_placeholder: "Voer het automodel in",
            year: "Bouwjaar",
            year_placeholder: "Voer het bouwjaar in",
            mileage: "Kilometerstand",
            mileage_placeholder: "Voer de kilometerstand in",
            car_state_placeholder: "Selecteer de staat van de wagen",
            car_information: "Autogegevens",
            message: "Bericht",
            message_placeholder: "Optionele extra informatie",
            images: "Upload foto's",
            images_hint: "U kunt meerdere foto's uploaden.",
            cancel: "Annuleren",
            submit: "Verzenden",
            car_state: "Staat van de auto",
            car_states: {
                excellent: "Uitstekend",
                very_good: "Zeer goed",
                good: "Goed",
                fair: "Redelijk",
                needs_repair: "Herstelling nodig"
            },
            success_title: "Gelukt !",
            success_message: "Uw formulier voor de verkoop van de auto is succesvol ingediend.",
            error_message: "Er is een fout opgetreden bij het indienen van uw autoverkoopformulier. Probeer het opnieuw."
        },

        description_car_detail: "Onze voertuigen zijn verkocht met:<br><br>\
        <ul>\
          <li>12 maanden garantie</li>\
          <li>Keuring voor verkoop</li>\
          <li>Onderhoud bij levering</li>\
          <li>Car-Pass</li>\
        </ul>\
        <br>\
        ENKEL OP AFSPRAAK",
        equipment: 'Uitrusting',

        colors: {
            black: 'Zwart',
            white: 'Wit',
            silver: 'Zilver',
            gray: 'Grijs',
            red: 'Rood',
            blue: 'Blauw',
            green: 'Groen',
            yellow: 'Geel',
            orange: 'Oranje',
            brown: 'Bruin',
            beige: 'Beige',
            gold: 'Goud',
            purple: 'Paars',
            pink: 'Roze',
            grey: 'Grijs',
        }, 

        privacy: {
            title: "Privacybeleid",
            last_updated: "Laatst bijgewerkt: 20 mei 2025",
            introduction: {
                title: "Inleiding",
                content: "Bij BASS MOTORS zijn we toegewijd aan de bescherming van uw privacy. Dit Privacybeleid legt uit hoe we uw informatie verzamelen, gebruiken, openbaar maken en beschermen wanneer u onze website bezoekt of onze diensten gebruikt."
            },
            data_collection: {
                title: "Gegevens die we verzamelen",
                content: "We kunnen persoonlijke informatie verzamelen die u vrijwillig aan ons verstrekt wanneer u:",
                items: [
                    "Registreert op onze website",
                    "Contact met ons opneemt via formulieren of e-mail",
                    "Interesse toont in onze voertuigen",
                    "Informatie aanvraagt over onze diensten",
                    "Een auto indient voor verkoop"
                ]
            },
            data_use: {
                title: "Hoe we uw gegevens gebruiken",
                content: "We gebruiken de verzamelde informatie om onze diensten te verlenen en te verbeteren, met u te communiceren, transacties te verwerken, uw ervaring te personaliseren en voor andere legitieme zakelijke doeleinden."
            },
            data_sharing: {
                title: "Deling van gegevens",
                content: "We verkopen uw persoonlijke informatie niet. We kunnen informatie delen met vertrouwde derden die ons helpen bij het exploiteren van onze website en het uitvoeren van onze activiteiten, mits deze partijen overeenkomen deze informatie vertrouwelijk te houden."
            },
            cookies: {
                title: "Cookies en trackingtechnologieën",
                content: "We gebruiken cookies en soortgelijke trackingtechnologieën om activiteiten op onze website te volgen en bepaalde informatie vast te houden om uw browse-ervaring te verbeteren. U kunt uw browser instrueren om alle cookies te weigeren of aan te geven wanneer een cookie wordt verzonden."
            },
            user_rights: {
                title: "Uw rechten",
                content: "Afhankelijk van uw locatie heeft u mogelijk bepaalde rechten met betrekking tot uw persoonlijke informatie, waaronder:",
                rights: [
                    "Het recht op toegang tot uw gegevens",
                    "Het recht om onjuiste gegevens te corrigeren",
                    "Het recht om verwijdering van uw gegevens te verzoeken",
                    "Het recht om de verwerking van uw gegevens te beperken",
                    "Het recht op gegevensoverdraagbaarheid",
                    "Het recht om toestemming in te trekken"
                ]
            },
            security: {
                title: "Gegevensbeveiliging",
                content: "We passen passende technische en organisatorische maatregelen toe om uw persoonlijke informatie te beschermen tegen ongeautoriseerde toegang, wijziging, openbaarmaking of vernietiging. Geen enkele internettransmissie of elektronische opslag is echter volledig veilig."
            },
            changes: {
                title: "Wijzigingen in dit beleid",
                content: "We kunnen ons privacybeleid van tijd tot tijd bijwerken. We zullen u op de hoogte brengen van eventuele wijzigingen door het nieuwe privacybeleid op deze pagina te plaatsen en de 'laatst bijgewerkte' datum bij te werken."
            },
            contact: {
                title: "Contacteer ons",
                content: "Als u vragen heeft over dit privacybeleid of uw persoonsgegevens, neem dan contact met ons op via onze contactpagina."
            }
        }
    },
    fr: {
        home: 'Accueil',
        all_vehicles: 'Tous les véhicules',
        about_us: 'À propos',
        contact_nav: 'Contact',
        sell_car: 'Vendez votre voiture',
        see_all_vehicles: 'Voir tous les véhicules',
        welcome_to_bass_motors: 'BIENVENUE CHEZ BASS MOTORS',
        search: 'Rechercher',
        all_brands: 'Toutes les marques',
        any_price: 'Tout prix',
        price_under_5000: 'Moins de €5 000',
        price_5000_10000: '€5 000 - €10 000',
        price_10000_20000: '€10 000 - €20 000',
        price_20000_50000: '€20 000 - €50 000',
        price_50000_100000: '€50 000 - €100 000',
        price_over_100000: 'Plus de €100 000',
        any_fuel_type: 'Tout type de carburant',
        fuel_types: {
            gasoline: 'Essence',
            diesel: 'Diesel',
            electric: 'Électrique',
            hybrid: 'Hybride',
            'electric/gasoline': 'Électrique/Essence',
            'electric/diesel': 'Électrique/Diesel'
        },
        latest_cars: 'Dernières voitures',
        customer_reviews: 'Avis des clients',
        quick_links: 'Liens rapides',
        contact_info: 'Coordonnées',
        opening_hours: 'Heures d\'ouverture',
        follow_us: 'Suivez-nous',
        copyright: '© {year} Bass Motors. Tous droits réservés.',
        monday_friday: 'Lundi - Vendredi: 10h00 - 18h00',
        saturday: 'Samedi: 10h30 - 18h00',
        sunday: 'Dimanche: Fermé',
        by_appointment_only: 'UNIQUEMENT SUR RENDEZ-VOUS',
        loading_car_details: 'Chargement des détails de la voiture...',
        back_to_listings: 'Retour à la liste',
        kilometers: 'km',
        specs: {
            make: 'Marque',
            model: 'Modèle',
            year: 'Année',
            price: 'Prix',
            mileage: 'Kilométrage',
            fuel_type: 'Type de carburant',
            transmission: 'Transmission',
            power: 'Puissance',
            doors: 'Portes',
            color: 'Couleur'
        },
        description: 'Description',
        no_description: 'Aucune description disponible.',
        interested_title: 'Intéressé par cette voiture?',
        interested_text: 'Contactez-nous pour plus d\'informations ou pour planifier un essai.',
        contact_seller: 'Contacter le vendeur',
        load_error: 'Échec du chargement des détails de la voiture',


        filter_options: "Options de filtrage",
        reset_all: "Réinitialiser tout",
        available_vehicles: "Véhicules disponibles",
        results: "résultats",
        loading_vehicles: "Chargement des véhicules...",
        error_title: "Quelque chose s'est mal passé",
        try_again: "Réessayer",
        no_vehicles_match: "Aucun véhicule ne correspond à vos critères",
        try_adjusting_filters: "Essayez d'ajuster vos filtres ou",
        reset_all_filters: "réinitialiser tous les filtres",
        sort: {
            price_low_to_high: "Prix: Croissant",
            price_high_to_low: "Prix: Décroissant",
            newest_first: "Plus récent d'abord",
            lowest_mileage: "Kilométrage le plus bas"
        },

        brand: "Marque",
        price_range: "Fourchette de prix",
        min_price: "Min €",
        max_price: "Max €",
        to: "à",
        fuel_type: "Type de carburant",

        transmissions: {
            manual: "Manuelle",
            automatic: "Automatique"
        },

        // about: {
        //     title: "À propos de nous",
        //     subtitle: "Votre partenaire de confiance pour trouver le véhicule parfait",
        //     our_story: "Notre Histoire",
        //     story_part1: "Depuis 2002, Bass Motors s'engage à proposer des véhicules d'occasion de haute qualité à des prix équitables. Avec plus de vingt ans d'expérience dans le secteur automobile, nous avons bâti une solide réputation fondée sur la confiance, la fiabilité et la satisfaction de nos clients.\n\nChez Bass Motors, notre objectif est simple : vous aider à trouver la voiture qui correspond à vos besoins et à votre budget, sans compromis. Chaque véhicule que nous vendons est soigneusement inspecté pour répondre à nos normes de qualité et de sécurité.\n\nQue vous achetiez votre première voiture ou que vous souhaitiez changer de modèle, vous pouvez compter sur notre équipe pour un conseil honnête, un service transparent et un accompagnement après la vente.\n\nVotre satisfaction est notre priorité.\nBienvenue chez Bass Motors – là où commence votre route.",
        //     story_part2: "Nous sommes fiers de notre processus rigoureux d'inspection des véhicules et de notre engagement à fournir des informations précises et détaillées sur chaque voiture de notre inventaire."
        // },
    
        about: {
            title: "À propos de nous",
            subtitle: "Engagés pour l'excellence depuis 2002.",
            our_story: "Notre histoire",
            story_part1: "Depuis 2002, Bass Motors s'engage à proposer des véhicules d'occasion de haute qualité à des prix équitables. Avec plus de vingt ans d'expérience dans le secteur automobile, nous avons bâti une solide réputation fondée sur la confiance, la fiabilité et la satisfaction de nos clients.",
            story_part2: "Votre satisfaction est notre priorité. Bienvenue chez Bass Motors — là où commence votre route."
        },
        
          
        
        contact: {
            title: "Contactez-nous",
            subtitle: "Vous avez des questions ? Envoyez-nous un message et nous vous répondrons dès que possible.",
            success_title: "Message envoyé !",
            success_message: "Merci de nous avoir contactés. Nous vous répondrons bientôt.",
            error_title: "Erreur d'envoi du message",
            error_message: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
            about_car: "Vous nous contactez au sujet de : {make} {model} ({year})",
        },

        contact_form: {
            name: "Nom",
            name_placeholder: "Votre nom",
            email: "Email",
            email_placeholder: "votre@email.com",
            phone: "Téléphone",
            phone_placeholder: "Votre numéro de téléphone",
            message: "Message",
            message_placeholder: "Votre message...",
            cancel: "Annuler",
            submit: "Envoyer",
            regarding_car: "Concernant le véhicule",
            message_about_car_placeholder: "Votre message concernant ce véhicule...",
        },

        car_power: {
            kilowatts: 'kW',
            horse_power: 'CH',
        },
        sell_car_form: {
            title: "Vendez votre voiture",
            subtitle: "Remplissez le formulaire ci-dessous pour commencer.",
            error_title: "Erreur lors de l'envoi du message",
            name: "Nom",
            name_placeholder: "Entrez votre nom",
            email: "Email",
            email_placeholder: "Entrez votre email",
            phone: "Téléphone",
            phone_placeholder: "Numéro de téléphone optionnel",
            brand: "Marque de voiture",
            brand_placeholder: "Entrez la marque de la voiture",
            model: "Modèle de voiture",
            model_placeholder: "Entrez le modèle de la voiture",
            year: "Année",
            year_placeholder: "Entrez l'année de fabrication",
            mileage: "Kilométrage",
            mileage_placeholder: "Entrez le kilométrage (km)",
            car_state_placeholder: "Sélectionnez l'état de la voiture",
            car_information: "Informations sur la voiture",
            message: "Message",
            message_placeholder: "Informations supplémentaires optionnelles",
            images: "Télécharger des photos",
            images_hint: "Vous pouvez télécharger plusieurs photos.",
            cancel: "Annuler",
            submit: "Soumettre",
            car_state: "État de la voiture",
            car_states: {
                excellent: "Excellent",
                very_good: "Très bon",
                good: "Bon",
                fair: "Passable",
                needs_repair: "À réparer"
            },
            success_title: "Succès !",
            success_message: "Votre formulaire de vente de voiture a bien été envoyé.",
            error_message: "Une erreur s'est produite lors de l'envoi de votre formulaire de vente de voiture. Veuillez réessayer."
        },

        description_car_detail: "Nos véhicules sont vendus avec:<br><br>\
        <ul>\
          <li>12 mois de garantie</li>\
          <li>Contrôle technique pour la vente</li>\
          <li>Entretien à la livraison</li>\
          <li>Car-Pass</li>\
        </ul>\
        <br>\
        UNIQUEMENT SUR RENDEZ-VOUS",
        equipment: 'Équipement',

        colors: {
            black: 'Noir',
            white: 'Blanc',
            silver: 'Argent',
            gray: 'Gris',
            red: 'Rouge',
            blue: 'Bleu',
            green: 'Vert',
            yellow: 'Jaune',
            orange: 'Orange',
            brown: 'Marron',
            beige: 'Beige',
            gold: 'Or',
            purple: 'Violet',
            pink: 'Rose',
            grey: 'Gris',
        }, 

        privacy: {
            title: "Politique de Confidentialité",
            last_updated: "Dernière mise à jour : 20 mai 2025",
            introduction: {
                title: "Introduction",
                content: "Chez BASS MOTORS, nous nous engageons à protéger votre vie privée. Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous visitez notre site Web ou utilisez nos services."
            },
            data_collection: {
                title: "Données que nous collectons",
                content: "Nous pouvons collecter des informations personnelles que vous nous fournissez volontairement lorsque vous :",
                items: [
                    "Vous inscrivez sur notre site Web",
                    "Nous contactez via des formulaires ou par e-mail",
                    "Exprimez de l'intérêt pour nos véhicules",
                    "Demandez des informations sur nos services",
                    "Soumettez une voiture à vendre"
                ]
            },
            data_use: {
                title: "Comment nous utilisons vos données",
                content: "Nous utilisons les informations collectées pour fournir et améliorer nos services, communiquer avec vous, traiter les transactions, personnaliser votre expérience et à d'autres fins commerciales légitimes."
            },
            data_sharing: {
                title: "Partage des données",
                content: "Nous ne vendons pas vos informations personnelles. Nous pouvons partager des informations avec des tiers de confiance qui nous aident à exploiter notre site Web et à gérer nos activités, à condition que ces parties acceptent de garder ces informations confidentielles."
            },
            cookies: {
                title: "Cookies et technologies de suivi",
                content: "Nous utilisons des cookies et des technologies de suivi similaires pour suivre l'activité sur notre site Web et conserver certaines informations afin d'améliorer votre expérience de navigation. Vous pouvez demander à votre navigateur de refuser tous les cookies ou de vous indiquer quand un cookie est envoyé."
            },
            user_rights: {
                title: "Vos droits",
                content: "En fonction de votre localisation, vous pouvez avoir certains droits concernant vos informations personnelles, y compris :",
                rights: [
                    "Le droit d'accéder à vos données",
                    "Le droit de corriger des données inexactes",
                    "Le droit de demander la suppression de vos données",
                    "Le droit de restreindre le traitement de vos données",
                    "Le droit à la portabilité des données",
                    "Le droit de retirer votre consentement"
                ]
            },
            security: {
                title: "Sécurité des données",
                content: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations personnelles contre tout accès, altération, divulgation ou destruction non autorisés. Cependant, aucune transmission sur Internet ou stockage électronique n'est totalement sécurisé."
            },
            changes: {
                title: "Modifications de cette politique",
                content: "Nous pouvons mettre à jour notre Politique de Confidentialité de temps à autre. Nous vous informerons de tout changement en publiant la nouvelle Politique de Confidentialité sur cette page et en mettant à jour la date de 'dernière mise à jour'."
            },
            contact: {
                title: "Contactez-nous",
                content: "Si vous avez des questions concernant cette Politique de Confidentialité ou vos données personnelles, veuillez nous contacter via notre page de contact."
            }
        }
        
    }
}

const numberFormats = {
    'en': {
        currency: {
            style: 'currency',
            currency: 'EUR',
            notation: 'standard'
        },
        number: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }
    },
    'nl': {
        currency: {
            style: 'currency',
            currency: 'EUR',
            notation: 'standard'
        },
        number: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true
        }
    },
    'fr': {
        currency: {
            style: 'currency',
            currency: 'EUR',
            notation: 'standard'
        },
        number: {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true
        }
    }
}

const i18n = createI18n({
    fallbackWarn: true,
    missingWarn: true,
    legacy: false,
    locale: 'nl',
    fallbackLocale: 'en',
    messages,
    numberFormats
})

// console.log(JSON.stringify(messages.en));

export default i18n
